import { render, staticRenderFns } from "./campaign.vue?vue&type=template&id=07d4f5b4&scoped=true"
import script from "./campaign.js?vue&type=script&lang=js&external"
export * from "./campaign.js?vue&type=script&lang=js&external"
import style0 from "./campaign.vue?vue&type=style&index=0&id=07d4f5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d4f5b4",
  null
  
)

export default component.exports